import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useFaqGroupsQuery } from "entities/faqs/queries/useFaqGroupsQuery";
import React, { FC, useState } from "react";
import { COLOR_BLACK, COLOR_GREY_12 } from "shared/theme/colors";
import { useFaqs } from "../../context";
import {
  StyledBox,
  StyledButtonsPopup,
  StyledCancelButton,
  StyledSaveButton,
  StyledModal,
  StyledTitle,
  StyledSelect,
} from "./styled";

type ChangeGroupModalProps = {
  open: boolean;
  onClose: () => void;
};

const ChangeGroupModal: FC<ChangeGroupModalProps> = ({ open, onClose }) => {
  const {
    handleChangeFaqGroup,
    changeGroupModalState,
    isFaqGroupChanging,
    faqGroupId,
  } = useFaqs();
  const { data: faqGroups } = useFaqGroupsQuery();
  const [selectedChangedGroupId, setSelectedChangedGroupId] = useState("");

  const handleSubmit = () =>
    handleChangeFaqGroup(
      changeGroupModalState.modalDetails,
      selectedChangedGroupId,
    );

  const formattedGroupsOptions =
    faqGroups
      ?.filter(({ id }) => id !== faqGroupId)
      .map((group) => ({
        value: group.id,
        label: group.title,
      })) ?? [];

  return (
    <StyledModal open={open} onClose={onClose}>
      <StyledBox>
        <Stack flexDirection="row">
          <Box />
          <StyledTitle variant="heading3" color={COLOR_BLACK}>
            Change group
          </StyledTitle>
        </Stack>
        <Typography variant="bodyLRegular" color={COLOR_GREY_12}>
          <StyledSelect
            value={selectedChangedGroupId ?? undefined}
            options={formattedGroupsOptions}
            handleChange={(e) => {
              setSelectedChangedGroupId(e);
            }}
          />
        </Typography>
        <StyledButtonsPopup>
          <StyledCancelButton
            title="Cancel"
            onClick={onClose}
            size="small"
            variant="outlined"
          />
          <StyledSaveButton
            title="Save"
            onClick={handleSubmit}
            size="small"
            loading={isFaqGroupChanging}
          />
        </StyledButtonsPopup>
      </StyledBox>
    </StyledModal>
  );
};

export default ChangeGroupModal;
